import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import styles from "./LinkedTitledTextItem.module.css";

type LinkedTitledTextItemProps = {
  text: string;
  toLink: string;
};

function LinkedTitledTextItem({ text, toLink }: LinkedTitledTextItemProps) {
  const navigate = useFixaNavigate();

  return (
    <FixaListView id="titled-text-list" size="small" showDivider={false}>
      <FixaListViewItem
        className={styles["wrap-content"]}
        title={text}
        control="navigational"
        controlIcon="chevronRightSmall"
        onClick={() => navigate(toLink)}
        type="button"
        inset
        showDivider={false}
      />
    </FixaListView>
  );
}

export default LinkedTitledTextItem;
